import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

const initialState: any = {
  searchFeedList: [],
  currentPage: 1,
  allPages: 0,
}
export const searchSlice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    handleCurrentPage: (state, { payload }): void => {
      state.currentPage = payload
    },
    handleSearchList: (state, { payload }): void => {
      state.searchFeedList = payload
    },
    handleAllPages: (state, { payload }): void => {
      state.allPages = payload
    },
  },
})
export const {
  handleCurrentPage,
  handleSearchList,
  handleAllPages,
} = searchSlice.actions
export const searchFeedReducer = (state: RootState) => state.searchFeedReducer

export default searchSlice.reducer
